import { render } from "./HeaderComp.vue?vue&type=template&id=f5048876"
const script = {}

import "./HeaderComp.vue?vue&type=style&index=0&id=f5048876&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__